import { Currency } from '@/core/currency/interfaces';

const GIP: Currency = {
    name: 'Gibraltar Pound',
    demonym: 'Gibraltar',
    majorSingle: 'Pound',
    majorPlural: 'Pounds',
    codeNumeric: '292',
    symbol: '£',
    symbolNative: '£',
    minorSingle: 'Penny',
    minorPlural: 'Pence',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'GIP',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default GIP;
